import { useField } from "formik";
import React from "react";
import { Form, Label, Checkbox } from "semantic-ui-react";

interface Props {
    name: string;
    label?: string;
}

export default function MyCheckbox(props: Props) {
    const [field, meta, helpers] = useField(props.name);
    
    return (
        <Form.Field>
            <Checkbox
                label={props.label}
                checked={field.value}
                onChange={() => helpers.setValue(!field.value)}
            />
            {meta.touched && meta.error ? (
                <Label basic color="red">{meta.error}</Label>
            ) : null}
        </Form.Field>
    );
}
